import { Injectable } from '@angular/core';
import { BaseWrapperService } from '../../shared/base-service/base-wrapper.service';
import { VehicleOwnershipDeInsuranceModel } from '../models/vehicle-ownership-de-insurance.model';
import { VehicleOwnershipModel } from '../models/vehicle-ownership.model';

@Injectable()
export class VehicleOwnershipDeInsuranceService extends BaseWrapperService {

    saveVehicleOwnershipDeInsurance = (vehicleOwnershipDeInsuranceModel: VehicleOwnershipDeInsuranceModel) => this.post('TitleRegistration/VehicleOwnershipDeInsurance/SaveVehicleOwnershipDeInsurance/', vehicleOwnershipDeInsuranceModel);

    newVehicleOwnershipDeInsurance = (vehicleOwnershipId: number) => this.get('TitleRegistration/VehicleOwnershipDeInsurance/New/' + vehicleOwnershipId);

    updateTitleRegistrationDeInsurance = (vehicleOwnershipModel: VehicleOwnershipModel, businessTransactionId: number) => this.post('TitleRegistration/VehicleOwnershipDeInsurance/UpdateTitleRegistrationDeInsurance/' + businessTransactionId, vehicleOwnershipModel);
    // removeSoldNotice = (vehicleOwnershipId: number) => {
    //    return this.post('TitleRegistration/SoldNotice/Remove/' + vehicleOwnershipId, null);
    // }
}
